import React from 'react';
import { triggerSignIn } from '@fiverr-private/identification_triggers';
import { I18n } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/button';
import { sendBigQueryEvent } from '../../../utils/bigQuery';
import { sendMixPanelEvent } from '../../../utils/mixPanel';
import { BIGQUERY_EVENT, MIXPANEL_EVENT } from '../../shared/constants';

export const LoginLink = () => {
    const path = pathfinder(
        'login',
        {},
        {
            query: {
                source: 'top_nav',
            },
        }
    );

    const handleClickTriggerApi = async (event) => {
        try {
            event.preventDefault();
            await triggerSignIn({ modalOptions: { source: 'header_login_link' } });
            sendBigQueryEvent(BIGQUERY_EVENT);
            sendMixPanelEvent(MIXPANEL_EVENT);
        } catch {
            window.location.assign(path);
        }
    };

    return (
        <Button rel="nofollow" href={path} onClick={handleClickTriggerApi} variant="ghost">
            <I18n k="header.sign_in" />
        </Button>
    );
};
